<template>
    <!--
    Error component
    Styled error messages using the validation plugin
    -->
    <transition name="fade">
        <div class="hint error" v-if="hasError">
            {{ message }}
        </div>
    </transition>
</template>

<script>
export default
{
    name: 'Error',

    props:
    {
        message:
        {
            required: false,
            type: String,
        }
    },

    computed:
    {
        hasError()
        {
            return (this.message != '');
        },
    }
}
</script>



// WEBPACK FOOTER //
// Error.vue?6919921e